export const SHARED_LOGS_KEYS = {
  notice: {
    verifyContract: 'shared.logs.notice.verifyContract',
  },
  actions: {
    verifyContract: 'shared.logs.actions.verifyContract',
  },
  fields: {
    transaction: 'shared.logs.fields.transaction',
    address: 'shared.logs.fields.address',
    decodedInputData: 'shared.logs.fields.decodedInputData',
    topics: 'shared.logs.fields.topics',
    data: 'shared.logs.fields.data',
    methodId: 'shared.logs.fields.methodId',
    call: 'shared.logs.fields.call',
    name: 'shared.logs.fields.name',
    type: 'shared.logs.fields.type',
    indexed: 'shared.logs.fields.indexed',
  },
  tooltip: {
    logIndex: 'shared.logs.tooltip.logIndex',
  },
  aria: {
    dataType: 'shared.logs.aria.dataType',
  },
  dataTypes: {
    hex: 'shared.logs.dataTypes.hex',
    address: 'shared.logs.dataTypes.address',
    text: 'shared.logs.dataTypes.text',
    number: 'shared.logs.dataTypes.number',
  },
} as const;
